module.exports = __webpack_public_path__ + "img/plus-secondary-thin.6569d321.svg";